import underConst from "../../assets/const.png";

const Register = () => {
  return (
    <div>
      <img
        style={{ width: "90%", margin: "4 rem 0" }}
        src={underConst}
        alt=""
      />
    </div>
  );
};

export default Register;
